export class PhpDataProvider {

    public readonly server:        string;
    public readonly regionId:      string;
    public readonly locale:        string;
    public readonly pageSeoString: string;
    public readonly accentMap:     {[key: string]: string};

    constructor() {
        // @ts-ignore - backendData jsou zapsane primo ve strance.
        const data = backendData;

        if (typeof data !== 'object'
            || typeof data.server !== 'string'
            || typeof data.regionId !== 'string'
            || typeof data.locale !== 'string'
            || typeof data.pageSeoString !== 'string'
            || typeof data.accentMap !== 'object'
        ) {
            throw new Error('');
        }

        this.server        = data.server;
        this.regionId      = data.regionId;
        this.locale        = data.locale;
        this.pageSeoString = data.pageSeoString;
        this.accentMap     = data.accentMap;
    }
}